import { picoapp } from 'picoapp'

import header from '@/components/header.js'
import productSelection from '@/components/product-selection.js'
import cartDrawer from '@/components/cartDrawer.js'
import cartDrawerItem from '@/components/cartDrawerItem.js'
import accountLogin from '@/components/accountLogin.js'
import collection from '@/components/collection.js'
import product from '@/components/product.js'
import productRecommendations from '@/components/product-recommendations.js'
import productCounter from '@/components/product-counter.js'
import addAllToCart from '@/components/addAllToCart.js'
import heroSlider from '@/components/heroSlider.js'
import featuredTestimonials from '@/components/featuredTestimonials.js'
import video from '@/components/video.js'
import instagramFeed from '@/components/instagramFeed.js'
import aboutSlider from '@/components/aboutSlider.js'
import accordionGroup from '@/components/accordionGroup.js'
import faqFilter from '@/components/faqFilter.js'
import newsletter from '@/components/newsletter.js'
import waterQualityReport from '@/components/waterQualityReport.js'

const state = {
  cartOpen: false,
  menuOpen: false,
  searchOpen: false
}

const components = {
  accountLogin,
  header,
  productSelection,
  cartDrawer,
  cartDrawerItem,
  collection,
  product,
  productRecommendations,
  productCounter,
  addAllToCart,
  heroSlider,
  featuredTestimonials,
  video,
  instagramFeed,
  aboutSlider,
  accordionGroup,
  faqFilter,
  newsletter,
  waterQualityReport
}

export default picoapp(components, state)
